import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

class DefaultOffer extends Component
{
    constructor(props)
    {
        super(props);
    }

    componentDidMount()
    {
        // Force Callrail swap
        if (window.CallTrk)
        {
            window.CallTrk.swap();
        }
    }

    render()
    {
        return (
            <>
                <Fade bottom>
                    <div className="tw-flex tw-flex-wrap lg:tw-justify-center">
                        <div className="tw-w-full lg:tw-w-2/3">
                            <h4 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mb-4 lg:tw-mb-6">
                                For up-to-date availability and promotions, please CALL US today at: <br />
                                <a className="hover:tw-text-orange-400" href="tel:18447858575">1 (844) 785-8575</a>.
                            </h4>


                        </div>
                    </div>
                </Fade>
                <Fade bottom>
                    <hr className="tw-border-gray-500 tw-w-full lg:tw-w-2/3 tw-m-auto tw-mt-10 lg:tw-mt-20" />
                </Fade>
            </>
        );
    }
}

DefaultOffer.propTypes = {};

export default DefaultOffer;
